<template>
  <div class="flock-card-header">
  <div class="flock-card-header-avatar" :style="{ 'background-color': info.author_info.logo.bg_color}">
    <img style="genLogoStyle(info.author_info.logo)"  :src="info.author_info.user_icon || info.author_info.logo.url" />
  </div>
  <div class="g-text-overflow">{{info.author_info.pull_black_name}}</div>
  <img v-if="info.author_info.is_official === 'Y'" class="flock-card-header-official" src="../image/is-official.png" />
  <div class="flock-card-header-date">{{timeSince(info.date, 'MM月dd日')}}</div>
  <div class="flock-card-header-placeholder">
    <img v-if="info.post_tag.icon" class="flock-card-header-tag" :src="info.post_tag.icon" />
  </div>
  <img class="flock-card-header-more" src="../image/more.png" @click.stop="menuClick" />
</div>
</template>

<script>
import { timeSince } from '../utils'

export default {
  name: 'FlockCardHeader',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    genLogoStyle () {
      return function (obj) {
        if (!obj || !obj.center || !obj.w_p || !obj.h_p) {
          return ''
        }
        var styleStr = ''
        // center = [x, y] 0.5为中心点，如果为0.4意思为往右或往下偏移10%
        var center = obj.center.split(',')
        center[0] = (0.5 - center[0]) * 100 * (1 / obj.w_p) + '%'
        center[1] = (0.5 - center[1]) * 100 * (1 / obj.h_p) + '%'
        styleStr += ';transform: translate(' + center[0] + ',' + center[1] + ') '
        styleStr += 'scale(' + (1 / obj.w_p) + ',' + (1 / obj.h_p) + ');'
        styleStr += ';-webkit-transform: translate('+ center[0] + ',' + center[1] +') '
        styleStr += 'scale(' + (1 / obj.w_p) + ',' + (1 / obj.h_p) + ');'

        return styleStr
      }
    },
    timeSince () {
      return timeSince
    }
  },
  methods: {
    menuClick () {
      this.$emit('menuClick')
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../mixins.less);

.flock-card-header{
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  padding: 16 / @ratio 0 10 / @ratio;
  // line-height: 1;
  font-size:22 / @ratio;
  // font-weight: bold;
  color:rgba(171,171,171,1);
}
.flock-card-header-avatar{
  .webkitCss(flex, 0 0 auto);
  .square(30 / @ratio);
  border-radius: 100px;
  margin-right: 16 / @ratio;
  overflow: hidden;
  img{
    display: block;
    .square(100%);
  }
}
.flock-card-header-placeholder{
  .webkitCss(flex, 1 0 124 / @ratio);
}
.flock-card-header-more{
  .webkitCss(flex, 0 0 auto);
  .square(56 / @ratio);
  margin-right: -12 / @ratio;
}

.flock-card-header-date{
  .webkitCss(flex, 0 0 auto);
  margin-left: 16 / @ratio;
}

.flock-card-header-tag{
  display: block;
  width:44 / @ratio;
  margin: 0 16 / @ratio 0 auto;
}

.flock-card-header-official{
  .round(24 / @ratio);
  margin-left: 8 / @ratio;
}
</style>

